import { Component, Input, OnInit } from '@angular/core'
import { DatePipe } from '@angular/common'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
const KEY = 'formulaire-information'

@Component({
	selector: 'atyl-formulaire-information',
	templateUrl: './formulaire-information.component.html',
	styleUrls: ['./formulaire-information.component.scss'],
})

@Stringable({
	path: 'views/partials/layout/formulaire-information',
	key: KEY,
})

export class FormulaireInformationComponent implements OnInit {
	@StringableValues(KEY)
	strings: any

	@Input() formulaire: any = {}
	message: string = ""

	constructor(
		private datePipe: DatePipe,
	) {}

	ngOnInit(): void {
		const form = this.formulaire.demandeFormulaire || this.formulaire

		if (!form) return

		if (form.createur!=undefined 
		&& form.createur ) {
			const createur = form.createur
			
			this.message += `Crée par : ${createur.prenom || ""} ${createur.nom || ""}\n`
			
			const creationDate = form.creationdate
			const formattedDate = this.datePipe.transform(new Date(creationDate), "dd LLLL yyyy")
			if (formattedDate) this.message += `Crée le ${formattedDate}`
			//console.log("FormulaireInformationComponent createur",createur,formattedDate)
			
		}
		
		
		if (form.modificateur!=undefined
		 && form.modificateur) {
			const modificateur = form.modificateur
			const modifDate = form.modificationdate
			const modifFormattedDate = this.datePipe.transform(new Date(modifDate), "dd LLLL yyyy")
           //console.log("FormulaireInformationComponent modificateur",modificateur,modifFormattedDate)
			this.message += `\n\nModifié par : ${modificateur.prenom || ""} ${modificateur.nom || ""}\n`
			if (modifFormattedDate) this.message += `Modifié le ${modifFormattedDate}`
		
			
		}
	}
}